"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeSchema = void 0;
var zod_1 = require("zod");
exports.BadgeSchema = zod_1.z.object({
    text: zod_1.z.string().nullish(),
    type: zod_1.z
        .enum([
        'THUMBNAIL_PRIMARY',
        'THUMBNAIL_MEMBER_CLASS_GOLD',
        'THUMBNAIL_TODAY',
        'THUMBNAIL_FILLED_PRIMARY',
        'THUMBNAIL_FILLED_SECONDARY',
        'THUMBNAIL_FILLED_BASIC',
        'THUMBNAIL_FILLED_WHITE',
        'THUMBNAIL_FILLED_BLACKOP',
        'THUMBNAIL_FILLED_WHITEOP',
        'THUMBNAIL_FILLED_ACCENT',
        'THUMBNAIL_FILLED_ACCENT_SECONDARY',
        'THUMBNAIL_OUTLINED_PRIMARY',
        'THUMBNAIL_OUTLINED_BASIC',
        'THUMBNAIL_COUNTDOWN_DATETIME',
        'COUNTDOWN_DAY',
        'COUNTDOWN_DATETIME',
        'BENEFIT_PRIMARY',
        'BENEFIT_SECONDARY',
        'BENEFIT_INFO',
        'BENEFIT_ACCENT',
        'BENEFIT_FILLED_PRIMARY',
        'BENEFIT_FILLED_SECONDARY',
        'BENEFIT_FILLED_BASIC',
        'BENEFIT_FILLED_WHITE',
        'BENEFIT_FILLED_BLACKOP',
        'BENEFIT_FILLED_WHITEOP',
        'BENEFIT_FILLED_ACCENT',
        'BENEFIT_FILLED_ACCENT_SECONDARY',
        'BENEFIT_OUTLINED_PRIMARY',
        'BENEFIT_OUTLINED_BASIC',
        'BENEFIT_COUNTDOWN_DAY',
        'BENEFIT_COUNTDOWN_DATETIME',
        'THUMBNAIL_NOLDAY',
    ])
        .nullish(),
});
